import { Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from '../../Utils/Common';
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  border: " 1px solid black",
}));


function TallyIntegrationReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };
  // //table sort_filter_functions
  // const pages = [5, 10, 25]
  // const [Page, setPage] = React.useState(0);
  // const [rowsPerPage, setrowsPerPage] =React.useState(pages[Page])
  // ///sort
  // const [order, setorder] = React.useState('asa')
  // const [orderBy, setorderBy] = React.useState('billName ')

  // const handleSortRequest = (property) => (event) => {
  //   handleSortReq(event, property)
  // }
  // const handleSortReq = (event, property) => {

  //   // const isAsc = orderBy === event && order === "asc"
  //   // setorder(isAsc ? 'desc' : 'asc ');
  //   // setorderBy()
  //   const isAscending = (orderBy === property && order === 'asc')
  //   setorderBy(property)
  //   setorder(isAscending ? 'desc' : 'asc')
  // }

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // }
  // const handleChangeRowsPerPage = (event) => {
  //   setrowsPerPage(parseInt(event.target.value, 10))
  //   setPage(0);
  // }
  // function stablesort(array, comparator) {
  //   const stabilizedThis = array.map((el, index) => [el, index]);
  //   stabilizedThis.sort((a, b) => {
  //     const order = comparator(a[0], b[0]);
  //     if (order !== 0) return order;
  //     return a[1] - b[1];
  //   })
  //   return stabilizedThis.map((el) => el[0]);
  // }
  // function getComparator(order, orderBy) {
  //   return order === 'desc'
  //     ? (a, b) => descendingComparator(a, b, orderBy)
  //     : (a, b) => -descendingComparator(a, b, orderBy);
  // }
  // function descendingComparator(a, b, orderBy) {
  //   if (b[orderBy] < a[orderBy]) {
  //     return -1;
  //   }
  //   if (b[orderBy] > a[orderBy]) {
  //     return 0;
  //   }
  // }

  // const recordsAfterPagingAndSorting = () => {
  //   return stablesort(details7, getComparator(order, orderBy)).slice(Page * rowsPerPage, (Page + 1) * rowsPerPage)
  // }

  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');

  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [loading, setloading] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [details5, setdetails5] = useState([]);
  const [details6, setdetails6] = useState([]);
  const [details7, setdetails7] = useState([]);
  const [TallyRepoValues, setTallyRepoValues] = useState({
    from: getDate(),
    to: getDate(),
    job: '',
    impnm: '-1',
    state: '-1',
    branch: '-1',
    fwnm: '-1',
    billby: '-1',
    billto: 'IMPORTER',
    ///summary
    totalJobNo: '0',
    taxablevalue: '0.00',
    cgstAmt: '0.00',
    sgstAmt: '0.00',
    igstAmt: '0.00',
    totalBillAmt: '0.00',
  });
  const fromhandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, to: e.target.value })
  };
  const impnmhandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, impnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const jobhandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, job: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const statehandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, state: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    var stateId = '';
    if (e.target.value === 'ALL') {
      stateId = '-1'
    } else {
      stateId = e.target.value;
    }
    BillingReportsService.getRegionBasedOnState(stateId).then(res => {
      setdetails3(res.data);
    })
  };
  const branchhandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const fwnmhandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, fwnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const billbyhandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, billby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const billtohandlechange = (e) => {
    setTallyRepoValues({ ...TallyRepoValues, billto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  ///keydown
  const [showProcs, setshowProcs] = useState(false)
  const [RefreshProcs, setRefreshProcs] = useState(false)
  const [ReportProcs, setReportProcs] = useState(false)
  ///clear summary
  const clearsummary = () => {
    setTallyRepoValues({ ...TallyRepoValues, totalJobNo: '', taxablevalue: '', cgstAmt: '', sgstAmt: '', igstAmt: '', totalBillAmt: '', })
  }
  ///getfunctions=====>
  const getimporter = () => {
    BillingReportsService.getImporterDetail().then(res => {
      setdetails1(res.data);
    })
  }
  const getstatename = () => {
    BillingReportsService.getDeliveryStateNameAll().then(res => {
      setdetails2(res.data);
    })
  }
  const getbranchRegion = () => {
    BillingReportsService.getRegionBasedOnState('-1').then(res => {
      setdetails3(res.data);
    })
  }
  const getforwarder = () => {
    BillingReportsService.selectFwdDetails().then(res => {
      setdetails4(res.data)
    })
  }
  const selectBillPaidBy = () => {
    BillingReportsService.selectBillPaidBy().then(res => {
      setdetails5(res.data);
    })
  }
  const getBillPaidToSelective = () => {
    BillingReportsService.getBillPaidToSelective().then(res => {
      setdetails6(res.data)
    })
  }
  ///button functions==========>
  const showOnclickBtn = () => {
    setloading(true)
    setshowProcs(true)
    setPage(0)
    setFilteredDetails([])
    setdetails7([])
    clearsummary();
    var billPaidTo, jobNo = '';
    if (TallyRepoValues.job === '') {
      jobNo = '-1'
    } else {
      jobNo = TallyRepoValues.job
    }
    if (TallyRepoValues.billto === 'FORWARDER') {
      billPaidTo = '2'
    } else if (TallyRepoValues.billto === 'IMPORTER') {
      billPaidTo = '1'
    } else {
      billPaidTo = '-1'
    }
    let details = {
      fromDate: TallyRepoValues.from, toDate: TallyRepoValues.to, consignmentId: jobNo,
      iecNo: TallyRepoValues.impnm, fwdcode: TallyRepoValues.fwnm, billPaidBy: TallyRepoValues.billby, billPaidTo: billPaidTo,
      deliveryStateId: TallyRepoValues.state, branchId: TallyRepoValues.branch
    }
    BillingReportsService.reportTallyIntegration(details).then((res) => {
      const data = res.data;
      const details = data.map((trns) => trns);
      if (details[0] === [] || !details[0]) {
        setMessage('No Data Found!!')
        setseverit('warning')
        setOpen(true)
        setloading(false)
        setshowProcs(false)
      } else {
        var totaljob = 0, valueTaxableAmount = 0, valueCGSTamount = 0, valueSGSTamount = 0, valueIGSTamount = 0, valueTotalBillAmount = 0;
        var jobCount = 0;
        var valueJob = "";
        for (let i = 0; i < details.length; i++) {
          if (details[i].consignmentId !== valueJob) {
            jobCount += 1;
            valueJob = details[i].consignmentId;
          }
          totaljob = jobCount;
          valueTaxableAmount += details[i].taxableValue;
          valueCGSTamount += details[i].cgstAmt;
          valueSGSTamount += details[i].sgstAmt;
          valueIGSTamount += details[i].igstAmt;
          valueTotalBillAmount = valueTaxableAmount + valueIGSTamount;
        }
        setTallyRepoValues({
          ...TallyRepoValues, totalJobNo: totaljob, taxablevalue: valueTaxableAmount, cgstAmt: valueCGSTamount.toFixed(2), sgstAmt: valueSGSTamount.toFixed(2),
          igstAmt: valueIGSTamount.toFixed(2), totalBillAmt: valueTotalBillAmount.toFixed(2)
        })
        setdetails7(res.data);
        setFilteredDetails(res.data);
        setloading(false)
        setshowProcs(false)
      }
    })
  }
  const RefreshBtn = () => {
    setRefreshProcs(true)
    setshowProcs(false)
    setTallyRepoValues({
      ...TallyRepoValues, from: getDate(), to: getDate(), job: '', impnm: '-1', fwnm: '-1', billby: '-1', billto: '-1', state: '-1', branch: '-1', totalJobNo: '0',
      taxablevalue: '0.00',
      cgstAmt: '0.00',
      sgstAmt: '0.00',
      igstAmt: '0.00',
      totalBillAmt: '0.00',
    })
    setFilteredDetails([])
    getbranchRegion()
    setRefreshProcs(false)
  }
  const WriteBtn = () => {
    setReportProcs(true)
    if (!details7[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setReportProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details7.length; i++) {
        if (details7[i].consignmentId !== '') {
          tableContent = details7[i].consignmentId + "!"
        } else {
          tableContent += '   !'
        }
        if (details7[i].billNo !== '') {
          tableContent += details7[i].billNo + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details7[i].invoiceDate !== '') {
          tableContent += details7[i].invoiceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].brName !== '') {
          tableContent += details7[i].brName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].iecName !== '') {
          tableContent += details7[i].iecName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].fwdName !== '') {
          tableContent += details7[i].fwdName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyName !== '') {
          tableContent += details7[i].partyName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].brAddress !== '') {
          tableContent += details7[i].brAddress + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyGstin !== '') {
          tableContent += details7[i].partyGstin + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyStateCode !== '') {
          tableContent += details7[i].partyStateCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billPaidBy !== '') {
          tableContent += details7[i].billPaidBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billPaidDate !== '') {
          tableContent += details7[i].billPaidDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].paymentType !== '') {
          tableContent += details7[i].paymentType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].voucherType !== '') {
          tableContent += details7[i].voucherType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].printedType !== '') {
          tableContent += details7[i].printedType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billName !== '') {
          tableContent += details7[i].billName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].hsnCode !== '') {
          tableContent += details7[i].hsnCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billType !== '') {
          tableContent += details7[i].billType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].taxableValue !== '') {
          tableContent += details7[i].taxableValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].cgstRate !== '') {
          tableContent += details7[i].cgstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].cgstAmt !== '') {
          tableContent += details7[i].cgstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].sgstRate !== '') {
          tableContent += details7[i].sgstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].sgstAmt !== '') {
          tableContent += details7[i].sgstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].igstRate !== '') {
          tableContent += details7[i].igstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].igstAmt !== '') {
          tableContent += details7[i].igstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].totalBillAmount !== '') {
          tableContent += details7[i].totalBillAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].boeNo !== '') {
          tableContent += details7[i].boeNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].boeDate !== '') {
          tableContent += details7[i].boeDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].desLocation !== '') {
          tableContent += details7[i].desLocation + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].termsPayment !== '') {
          tableContent += details7[i].termsPayment + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].dispatchDocNo !== '') {
          tableContent += details7[i].dispatchDocNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].containerNo !== '') {
          tableContent += details7[i].containerNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].salesLeger !== '') {
          tableContent += details7[i].salesLeger + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyAlias !== '') {
          tableContent += details7[i].partyAlias + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].roundAmount !== '') {
          tableContent += details7[i].roundAmount + "#"
        } else {
          tableContent += "   #";
        }
        contenall += tableContent;
      }
      let details = {
        headerName: "3,0,TALLY INTEGRATION REPORT", headerDetails: "1,1,FROM DATE : " + TallyRepoValues.from + "/4,1,TO DATE : " + TallyRepoValues.to,
        tableHeader: "0,3,Sl.No/1,3,Job No/2,3,Invoice No/3,3,Invoice Date/4,3,Branch/5,3,Importer Name/6,3,Forwarder Name/7,3,Party Name/8,3,Party Address/9,3,Party Gstin/10,3,Party State/11,3,paid By/12,3,Paid Date/13,3,Payment Type/14,3,Voucher Type/15,3,Printed Type/16,3,Description/17,3,HSN Code/18,3,Description Code/19,3,Taxable Value/20,3,CGST Rate/21,3,CGST Amount/22,3,SGST Rate/23,3,SGST Amount/24,3,IGST Rate/25,3,IGST Amount/26,3,Total Bill Amount/27,3,BE No/28,3,BE Date/29,3,DestinationLocation/30,3,Terms of Payment/31,3,DispatchDocNo/32,3,ContainerNo/33,3,Sales Leger/34,3,Party Alais/35,3,Round off Amount",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "Tally", totalNumberOfColumn: 36, tableContent: contenall.substring(0, contenall.length - 1),
      }
      BillingReportsService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
      })
    }
    setReportProcs(false)
  }
  ////
  const handleClose = () => {
    setOpen(false)
  }
  ///
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getimporter();
    getstatename();
    getbranchRegion();
    getforwarder();
    selectBillPaidBy();
    getBillPaidToSelective();
  }, []);

  ///table
  const jobnoSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const invoiceNoSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { invoiceNoOnchange(e.target.value) }} />
  }
  const branchSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { branchonchange(e.target.value) }} />
  }
  const imp_expSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { imp_expOnchange(e.target.value) }} />
  }
  const forwarderNmSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { forwarderNmOnchange(e.target.value) }} />
  }
  const partystateSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { partystateOnchange(e.target.value) }} />
  }
  const pymntTypeSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { pymntTypeOnchange(e.target.value) }} />
  }
  const des_locSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { des_locOnchange(e.target.value) }} />
  }
  const mdOfPymntSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { mdOfPymntOnchange(e.target.value) }} />
  }
  const containerSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { containerOnchange(e.target.value) }} />
  }

  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.consignmentId.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.billNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const branchonchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.brName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const imp_expOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.iecName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const forwarderNmOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.fwdName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const partystateOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.partyStateCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const pymntTypeOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.paymentType.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const des_locOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.desLocation.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const mdOfPymntOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.termsPayment.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const containerOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.containerNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }

  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        {/* ////// */}
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Grid container>
              <Grid item xs={8}>
                <Row>
                  <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>TALLY INTEGRATION REPORT</center></div>
                  <Col xs={3}>
                    <label style={mystyle1}>FromDate</label>
                  </Col>
                  <Col>
                    <Form.Control size="sm" type="date" style={mystyle} value={TallyRepoValues.from} onChange={fromhandlechange} />
                  </Col>
                  <Col>
                    <label style={mystyle1}>ToDate</label>
                  </Col>
                  <Col>
                    <Form.Control size="sm" type="date" style={mystyle} value={TallyRepoValues.to} onChange={tohandlechange} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>Job_No</label>
                  </Col>
                  <Col>
                    <Form.Control
                      size="sm"
                      type="text"
                      style={mystyle} value={TallyRepoValues.job} onChange={jobhandlechange}
                    ></Form.Control>
                  </Col>
                  <Col>
                    <label style={mystyle1}>ImporterName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={TallyRepoValues.impnm} onChange={impnmhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details1.map(trns => (
                        <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>StateName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={TallyRepoValues.state} onChange={statehandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details2.map(trns => (
                        <option value={trns.deliveryStateId}>{trns.deliveryStateName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>BranchName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={TallyRepoValues.branch} onChange={branchhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details3.map(trns => (
                        <option value={trns.regionId}>{trns.regionName}</option>
                      ))}
                      {/* ///regionId */}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>ForwarderName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={TallyRepoValues.fwnm} onChange={fwnmhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details4.map(trns => (
                        <option value={trns.fwdId}>{trns.fwdName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>BillPaid_By</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={TallyRepoValues.billby} onChange={billbyhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details5.map(trns => (
                        <option value={trns.billPaidBy}>{trns.billPaidBy}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>PrintBill_To</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={TallyRepoValues.billto} onChange={billtohandlechange} >
                      <option></option>
                      {details6.map(trns => (
                        <option value={trns.billPaidTo}>{trns.billPaidTo}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col lg={4}></Col>
                </Row>
                <center><Col lg={5} className="mt-2 mb-1">
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" onClick={showOnclickBtn}>{showProcs ? 'processing...' : 'Show'}</Button>{" "}
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={RefreshBtn}>{RefreshProcs ? 'processing...' : 'Refresh'}</Button>{" "}
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={WriteBtn}>{ReportProcs ? 'processing...' : 'Report'}</Button>
                </Col></center>
              </Grid>
              <Grid item xs={4}>
                <ItemPap1>
                  <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"}>
                    Summary
                  </Typography>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalJobNo</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{TallyRepoValues.totalJobNo}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TaxableValue</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{TallyRepoValues.taxablevalue}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>CGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{TallyRepoValues.cgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>sgstAmt</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{TallyRepoValues.sgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>igstAmt</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{TallyRepoValues.igstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>totalBillAmt</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{TallyRepoValues.totalBillAmt}</Form.Label></Col>
                  </Row>
                </ItemPap1>
              </Grid>
            </Grid>
            {/* ////////////////////////////////////// */}
            <ItemPap1>
              <TableContainer sx={{ height: 290 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow >
                      <StyledTableCell style={{ fontSize: '13px' }}>SlNo</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>JobNo {jobnoSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>InvoiceNo{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>InvoiceDate</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Branch{branchSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Importer_ExporterName{imp_expSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>ForwarderName{forwarderNmSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>PartyName</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>PartyAddress</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>PartyGSTIN</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>PartyState{partystateSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>PaidBy</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Bill_Paid_Date</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Payment_Type{pymntTypeSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Voucher_Type</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Printed_Type</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Description</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>HSN_Code</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>DescriptionCode</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Taxable_Value</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>CGST_Rate</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>CGST_Amount</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>SGST_Rate</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>SGST_Amount</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>IGST_Rate</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>IGST_Amount</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>TotalBillAmount</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>BE_No</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>BE_Date</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Dest_Location{des_locSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Mode_Of_Payment{mdOfPymntSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Dispatch_DocNo</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>ContainerNo{containerSrch()}</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Sales_Ledger</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Party_Alais</StyledTableCell>
                      <StyledTableCell style={{ fontSize: '13px' }}>Round_Off_Amount</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentId}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.brName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.fwdName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyGstin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyStateCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.paymentType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.voucherType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.printedType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hsnCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.taxableValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalBillAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boeNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boeDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.desLocation}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.termsPayment}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dispatchDocNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containerNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.salesLeger}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyAlias}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.roundAmount}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}
export default TallyIntegrationReport;
